import createReactComponent from '../createReactComponent';
export default createReactComponent('status-change', 'IconStatusChange', [
  ['path', { d: 'M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-0' }],
  ['path', { d: 'M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-1' }],
  ['path', { d: 'M6 12v-2a6 6 0 1 1 12 0v2', key: 'svg-2' }],
  ['path', { d: 'M15 9l3 3l3 -3', key: 'svg-3' }],
]);
